import { IActionButtons } from '@/components/atoms/confirmation-dialog/RestartTripDialog';
import {
  AIRCRAFT_TYPE_KEY,
  JETCARD_SIGNED_SOURCE,
  JETCARD_TYPE_KEY,
  TRIP_CREATION_SOURCE,
  TRIP_TYPE_KEY,
} from './enum';

export const DEFAULT_BROKER_COMMISSION_PERCENTAGE = 0.10; // 10%

export const IDLE_TIMER_TIMEOUT = 120 * 60; // 2 hours in seconds

// font family
export const FONT_WEIGHT = {
  BOLD: 'bold',
  MEDIUM: 'medium',
  REGULAR: 'regular',
  LIGHT: 'light',
};

// Text Align
export const TEXT_ALIGN = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
};

// InputText status
export const IS_FOCUS = 'IS_FOCUS';
export const IS_SUCCESS = 'IS_SUCCESS';
export const IS_ERROR = 'IS_ERROR';
export const IS_EDITABLE = 'IS_EDITABLE';
export const IS_BLUR = 'IS_BLUR';
export const IS_GRAYED_OUT = 'IS_GRAYED_OUT';

export const userConstants = {
  LOGIN_RESPONSE: 'LOGIN_RESPONSE',
  SET_READ_ONLY_POP_UP_FLAG: 'SET_READ_ONLY_POP_UP_FLAG',
};

export const allContactStatusView: any = {
  NewContact: 'New Contact',
  PotentialClient: 'Potential Client',
  Initiated: 'Initiated',
  Client: 'Client',
  Reject: 'Reject',
  Qualified: 'Potential Client',
  NotInterested: 'Reject',
  NoAnswer: 'Reject',
  FormerClient: 'Former Client',
};

export const sourceData = [
  { sourceId: 1, source: 'ClientReferral', name: 'Client Referral' },
  {
    sourceId: 11, source: 'Offline',
    name: 'Offline',
  },
  { sourceId: 11, source: 'Website', name: 'Website' },

];

export const genderData = [ 'Male', 'Female', 'Prefer not to Say' ];
export const documentTypeData = [ 'Driving Lisence', 'Passport', 'Other' ];
export const usCountryCode = 233;

export const KnockNotificationConfig = {
  apiKey: 'pk_test_zjiOWB-qBkwQqsXFvEu8gIgrWRNc_wQBROARbAl-kOM',
  feedId: 'inapptest',
};

export const TRIP_TYPE = [ { id: 1, key: TRIP_TYPE_KEY.CHARTER, displayName: 'Charter' }, { id: 2, key: TRIP_TYPE_KEY.JET_CARD, displayName: 'Jet Card' } ];

export const JETCARD_TYPE = [ { id: 3, key: JETCARD_TYPE_KEY.ALL_ACCESS, displayName: JETCARD_TYPE_KEY.ALL_ACCESS }, { id: 2, key: JETCARD_TYPE_KEY.ALL_IN, displayName: JETCARD_TYPE_KEY.ALL_IN } ];

export const AIRCRAFT_TYPE_LIST = [
  { id: 1, key: AIRCRAFT_TYPE_KEY.PISTON, label: 'Piston', type: [ TRIP_TYPE_KEY.CHARTER ], avinodeCategory: 'Piston' },
  { id: 2, key: AIRCRAFT_TYPE_KEY.TURBO_PROP, label: 'Turbo Prop', type: [ TRIP_TYPE_KEY.CHARTER ], avinodeCategory: 'Turbo prop' },
  { id: 3, key: AIRCRAFT_TYPE_KEY.VLJ, label: 'VLJ', type: [ TRIP_TYPE_KEY.CHARTER ], avinodeCategory: 'Entry level jet (VLJ)' },
  { id: 4, key: AIRCRAFT_TYPE_KEY.LIGHT, label: 'Light', type: [ TRIP_TYPE_KEY.JET_CARD, TRIP_TYPE_KEY.CHARTER ], avinodeCategory: 'Light jet' },
  { id: 5, key: AIRCRAFT_TYPE_KEY.MID, label: 'Mid', type: [ TRIP_TYPE_KEY.JET_CARD, TRIP_TYPE_KEY.CHARTER ], avinodeCategory: 'Super light jet' },
  { id: 6, key: AIRCRAFT_TYPE_KEY.SUPER_MID, label: 'Super-Mid', type: [ TRIP_TYPE_KEY.JET_CARD, TRIP_TYPE_KEY.CHARTER ], avinodeCategory: 'Super midsize jet' },
  { id: 7, key: AIRCRAFT_TYPE_KEY.HEAVY, label: 'Heavy', type: [ TRIP_TYPE_KEY.JET_CARD, TRIP_TYPE_KEY.CHARTER ], avinodeCategory: 'Heavy jet' },
  { id: 8, key: AIRCRAFT_TYPE_KEY.OTHER, label: 'Other', type: [ TRIP_TYPE_KEY.CHARTER ], avinodeCategory: 'VIP airliner' },
];

export const TRIP_STATUS_MAP_LIST = [
  {
    id: 0,
    display_name: 'Unknown',
    description: null,
    display_name_new: 'Unknown',
    class: 'Unknown',
  },
  {
    id: 1,
    display_name: 'Quote Open',
    description: null,
    display_name_new: 'Scheduling',
    class: 'SchedulingPricingProposal',
  },
  {
    id: 2,
    display_name: 'Quote to Broker',
    description: null,
    display_name_new: 'Quote Review',
    class: 'QuoteReview',
  },
  {
    id: 3,
    display_name: 'Sent to Client',
    description: null,
    display_name_new: 'Client Review',
    class: 'ClientReview',
  },
  {
    id: 4,
    display_name: 'Accepted',
    description: null,
    display_name_new: 'Accepted',
    class: 'Accepted',
  },
  {
    id: 5,
    display_name: 'Assignment Made',
    description: null,
    display_name_new: 'Assignment Made',
    class: 'AssignmentMade',
  },
  {
    id: 6,
    display_name: 'Unknown',
    description: null,
    display_name_new: 'Unknown',
    class: 'Unknown',
  },
  {
    id: 7,
    display_name: 'Completed',
    description: null,
    display_name_new: 'Finance Review',
    class: 'FinanceReview',
  },
  {
    id: 8,
    display_name: 'Finalized',
    description: null,
    display_name_new: 'Finalized',
    class: 'Finalized',
  },
  {
    id: 9,
    display_name: 'Cancelled',
    description: null,
    display_name_new: 'Cancelled Without Cost',
    class: 'Cancelled',
  },
  {
    id: 10,
    display_name: 'Cancelled with Cost',
    description: 'This is the non-finalized Cancelled With Cost status',
    display_name_new: 'Cancelled With Cost',
    class: 'Cancelled',
  },
  {
    id: 11,
    display_name: 'Cancelled and Finalized',
    description: 'This is the finalized Cancelled With Cost status',
    display_name_new: 'Cancelled With Cost',
    class: 'Cancelled',
  },
  {
    id: 12,
    display_name: 'Jet Card Pending',
    description: null,
    display_name_new: 'Pricing and Proposal',
    class: 'SchedulingPricingProposal',
  },
  {
    id: 13,
    display_name: 'Broker to Review',
    description: 'Indicates to the broker that they have not added in all trip fees or are currently in the process of finalizing that trip.',
    display_name_new: 'Trip Review',
    class: 'TripReview',
  },
  {
    id: 14,
    display_name: 'Draft',
    description: 'Indicates to the broker that they have not added in all trip fees or are currently in the process of finalizing that trip.',
    display_name_new: 'Draft',
    class: 'Draft',
  },
  {
    id: 15,
    display_name: 'Partially Assigned',
    description: 'Partially Assigned :  Not all legs have Operator assigned. ',
    display_name_new: 'Partially Assigned',
    class: 'PartiallyAssigned',
  },
  { // Not in use
    id: 16,
    display_name: 'Broker to Review',
    description: 'Indicates to the broker that they have not added in all trip fees or are currently in the process of finalizing that trip.',
    display_name_new: 'Trip Review',
    class: 'TripReview',
  },
  {
    id: 17,
    display_name: 'Quote to Broker',
    description: 'Substatus of: 2 - Quote to Broker. Indicates trip at Broker and Broker added options on the trip',
    display_name_new: 'Quote Review',
    class: 'QuoteReview',
  },
  {
    id: 18,
    display_name: 'Quote to Broker',
    description: null,
    display_name_new: 'Quote Review',
    class: 'QuoteReview',
  },
  {
    id: 19,
    display_name: 'Jet Card Pending',
    description: 'Substatus of: 12 - Jet Card Pending. Indicates trip at Jet Card Pending and Broker saved proposal',
    display_name_new: 'Pricing and Proposal',
    class: 'Scheduling',
  },
  { // Not in use
    id: 20,
    display_name: 'Jet Card Pending',
    description: 'Substatus of: 12 - Jet Card Pending. Indicates trip at Jet Card Pending and Broker saved Contract',
    display_name_new: 'Pricing and Proposal',
    class: 'Scheduling',
  },
  {
    id: 21,
    display_name: 'Ongoing Trip',
    description: '',
    display_name_new: 'Ongoing Trip',
    class: 'OngoingTrip',
  },
];

export const TRIP_LEG_STATUS_MAP_LIST = [
  {
    id: 1,
    display_name: 'In Queue',
  },
  {
    id: 2,
    display_name: 'Quote Review',
  },
  {
    id: 3,
    display_name: 'Client Review',
  },
  {
    id: 4,
    display_name: 'Accepted',
  },
  {
    id: 5,
    display_name: 'Scheduler Assigned',
  },
  {
    id: 6,
    display_name: 'Draft',
  },
  {
    id: 7,
    display_name: 'Operator Assigned',
  },
  {
    id: 8,
    display_name: 'In Transit',
  },
  {
    id: 9,
    display_name: 'Completed',
  },
];

// Trip LegStatus
export const tripLegDotStatus: any = {
  'Draft': 'draft',
  'In Queue': 'inQueue',
  'Scheduler Assigned': 'schedulerAssigned',
  'Quote Review': 'quoteReview',
  'Client Review': 'clientReview',
  'Accepted': 'accepted',
  'Operator Assigned': 'operatorAssigned',
  'In Transit': 'inTransit',
  'Completed': 'completed',
  'Cancelled': 'cancelled',
};

export const RESTART_DIALOG_MESSAGE = 'Are you sure you want to restart?';
export const RESTART_DIALOG_MESSAGE_DETAILS = {
  paragraph: 'Restarting will:',
  items: [ 'Void the original contract', 'Drop the credit card hold', 'Require a new agreement to be sent and signed' ],
};

export const RESTART_CONFIRMATION_ACTIONS: IActionButtons = {
  acceptButton: {
    accept: 'Restart',
    acceptColor: 'error',
  },
  declineButton: {
    decline: 'Cancel',
    declineColor: 'base',
    fillMode: 'outline',
  },
};

export const UPDATE_TRIP_DIALOG = {
  title: 'Choose how to update this trip',
  quickEditButtonText: 'Quick Edit',
  quickEditDescription: 'Update existing details here',
  restartButtonText: 'Restart',
  restartDescription: 'Start from scratch',
};

export const messageForCVV: string = 'You can find your 3-digit security code (CVV) in the signature on the back of your card after the credit card number';

/**
 * Company information constants
 */
export const COMPANY_INFO = {
  NAME: 'JETS.COM',
  ADDRESS: '1441 South Ave, Suite 607, New York, NY 10314',
  BANK_WIRE_ADDRESS: '450 Penn Street Reading, PA 19601',
};

export const PROMOTION_NAME_THAT_DOES_NOT_REQUIRE_VALIDATION = 'Dan Approved';

export const TRIP_CREATION_SOURCE_DISPLAY_NAME: Record<TRIP_CREATION_SOURCE, string> = {
  [TRIP_CREATION_SOURCE.COPILOT]: 'Copilot',
  [TRIP_CREATION_SOURCE.MAVERICK]: 'Maverick',
};

/** Label for trips created in Salesforce, after the Salesforce rollout's project name. */
export const SALESFORCE_TRIP_LABEL = 'Iceman';

export const JETCARD_SIGNED_SOURCE_DISPLAY_NAME: Record<JETCARD_SIGNED_SOURCE, string> = {
  [JETCARD_SIGNED_SOURCE.COPILOT]: 'Copilot',
  [JETCARD_SIGNED_SOURCE.WEB]: 'Web',
};

export enum CopilotStatus {
  INACTIVE = 'inactive',
  INVITED = 'invited',
  EXPIRED = 'expired',
  ACTIVATED = 'activated',
}
